import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "../styles/PaymentResult.css";

export default function PaymentResult() {
  const navigate = useNavigate();

  useEffect(() => {
    const savedChatId = sessionStorage.getItem("checkout_chat_id");

    const t = setTimeout(() => {
      navigate("/", {
        replace: true,
        state: {
          checkoutSuccess: true,
          openChatId: savedChatId || null,
        },
      });
    }, 1200);

    return () => clearTimeout(t);
  }, [navigate]);

  return (
    <div className="paymentResultWrap">
      <div className="paymentResultCard">
        <div className="paymentSkeletonTitle" />
        <div className="paymentSkeletonLine" />
        <div className="paymentSkeletonLine short" />

        <div className="paymentSkeletonImages">
          {Array.from({ length: 3 }).map((_, i) => (
            <div key={i} className="paymentSkeletonImg" />
          ))}
        </div>
      </div>
    </div>
  );
}